<script>
  import IconButton from './IconButton.svelte';
  import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
</script>

<IconButton title="Edit" on:click icon={faPencilAlt} />